module.exports = __webpack_public_path__ + "static/media/Cotton_Green.bac8e6a3.svg";